var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96983 3.25651L9.40183 2.36963L8.51495 6.80163C8.42211 7.26616 8.19389 7.69283 7.85903 8.0279C7.52417 8.36298 7.09765 8.59147 6.63318 8.68461L2.20117 9.57029L3.08805 5.13828C3.18111 4.67397 3.40942 4.24756 3.74426 3.91272C4.07911 3.57788 4.50552 3.34956 4.96983 3.25651Z",
    stroke: "#5F5F5F",
    strokeWidth: 3.1884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.30ffc0d01114678fc3b2371568663fe0.svg";
export { ForwardRef as ReactComponent };